import * as React from 'react';

function SvgIconSearch(props) {
    return (
        <svg width={50} height={50} {...props}>
            <path d='M22.9 16.7c-3.4 0-6.1 2.8-6.1 6.1s2.8 6.1 6.1 6.1c3.4 0 6.1-2.8 6.1-6.1s-2.7-6.1-6.1-6.1zm0 10.3c-2.3 0-4.1-1.9-4.1-4.1s1.9-4.1 4.1-4.1c2.3 0 4.1 1.9 4.1 4.1S25.2 27 22.9 27zM27.888 28.999l1.414-1.414 3.748 3.747-1.414 1.415z' />
        </svg>
    );
}

export default SvgIconSearch;
